666<template>
  <div class="appointment-type">
    <ph-tabs v-model="active" :list="tabs" @tabClick="tabChange" />
    <ph-search
      v-model="keyWrod"
      :placeholder="active === 'department' ? '搜索科室' : '搜索医生'"
    />
    <DepartmentListView
      v-if="active === 'department'"
      :list="getList"
      :qrtype="qrtype"
      class="appointment-type-list"
    />
    <DoctorListView
      v-else
      :list="getList"
      :qrtype="qrtype"
      class="appointment-type-list"
    />
  </div>
</template>

<script>
import DepartmentListView from "./components/DepartmentList";
import DoctorListView from "./components/DoctorList";

export default {
  components: {
    DepartmentListView,
    DoctorListView,
  },
  data() {
    return {
      active: "department",
      tabs: [
        { name: "按科室预约", id: "department" },
        { name: "按医生预约", id: "doctor" },
      ],
      keyWrod: "",
      departmentList: [],
      doctorList: [],
      qrtype: "1",
    };
  },
  computed: {
    getList() {
      const list =
        this.active === "department" ? this.departmentList : this.doctorList;
      const reg = new RegExp(this.keyWrod);
      const arr = [];
      for (let i = 0; i < list.length; i += 1) {
        if (reg.test(list[i].title)) {
          arr.push(list[i]);
        }
      }
      return arr;
    },
  },
  watch: {
    $route(to) {
      if (to.path === "/home") {
        this.active = "department";
        this.keyWrod = "";
        this.departmentList = [];
        this.doctorList = [];
      }
    },
  },
  activated() {
    this.qrtype = this.$route.query.qrtype || "1";
    this.initDepartmentList();
  },
  methods: {
    initDepartmentList() {
      if (this.departmentList.length) return;
      this.$http.post(this.$api.APPOINTMENT_DEPARTMENT_LIST).then((res) => {
        this.departmentList = res.map((item) => {
          return {
            id: item.appointOfficeCode,
            title: item.appointOfficeName,
            flag: item.flag,
            address: item.address,
          };
        });
      });
    },
    initDoctorList() {
      this.$http.post(this.$api.APPOINTMENT_DOCTOR_LIST).then((res) => {
        this.doctorList = res.map((item) => {
          return {
            title: item.appointDoctorName,
            id: item.appointDoctorCode,
            intro: item.intro,
            department: item.appointOfficeName,
            departmentId: item.appointOfficeCode,
            portrait: item.photourl,
            level: item.levelname,
          };
        });
      });
    },
    tabChange(_, tab) {
      if (tab === "doctor" && !this.doctorList.length) {
        this.initDoctorList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.appointment-type {
  overflow: hidden !important;

  &-list {
    height: calc(100% - 6rem);
    padding: 5px;
    overflow: scroll;
  }
}
</style>
